import { render, staticRenderFns } from "./DataDict.vue?vue&type=template&id=69b6848b&scoped=true"
import script from "./DataDict.vue?vue&type=script&lang=js"
export * from "./DataDict.vue?vue&type=script&lang=js"
import style0 from "./DataDict.vue?vue&type=style&index=0&id=69b6848b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b6848b",
  null
  
)

export default component.exports